<div class="title" fxLayout="row" fxLayoutAlign="start">
  <span mat-dialog-title role="heading" aria-level="1">Please Select Account Type</span>
</div>
<mat-dialog-content fxLayoutAlign="center" fxLayout="column">
  <mat-form-field floatLabel="always" appearance="outline">
    <mat-label>Account Type</mat-label>
    <mat-select fxFlex="auto" name="accountType" [(ngModel)]="selectedAccountType" ngModel>
      <mat-option *ngFor="let accountType of accountTypes" [value]="accountType">
        {{accountType.value}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="selectedAccountType?.id == UserRole.Protester">
    <h3> Request Protester/Intervenor Access to:</h3>
    <ul>
      <li>Visit an EPDS web page that indicates a Vendor account is necessary</li>
      <li>File a new protest</li>
      <li>Intervene in an existing protest</li>
    </ul>
  </div>
  <div *ngIf="selectedAccountType?.id == UserRole.Agency_Attorney">
    <h3> Request Agency Representative Access to:</h3>
    <ul>
      <li>Visit an EPDS web page that indicates an Agency Representative account is necessary</li>
      <li>Represent yourself as an agency representative</li>
      <li>Participate in protests associated with agencies you are representing</li>
    </ul>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
  <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onOk()">Ok</button>
</mat-dialog-actions>
